export const holidaysSelector = state => state?.holidays?.get('results')?.toArray()
